<template>
  <div class="notifications-container">
    <h1 class="title">🚸 Parent In School Premisis</h1>

    <div v-if="parentAlerts.length === 0" class="empty-state">
      <p>No alerts yet.</p>
    </div>

    <transition-group name="fade" tag="div" class="alerts-grid">
      <div
        v-for="alert in parentAlerts"
        :key="alert.student_id"
        class="alert-card"
      >
        <!-- <div class="icon">
          <img src="@/assets/parent-icon.png" alt="Parent Icon" />
        </div> -->
        <div class="details">
          <p class="parent-name">
            👤 <strong>{{ alert.parent_name }}</strong>
          </p>
          <p class="student-name">
            🧒 For <strong>{{ alert.student_name }}</strong>
          </p>
          <p class="location">
            📍 Nearby the school
          </p>
        </div>
      </div>
    </transition-group>
  </div>
</template>


<script>
import axios from 'axios';
export default {
  name: 'ParentArriving',
  data() {
    return {
      parentAlerts: [],
    };
  },
  mounted() {
    // this.fetchAlertsFromBackend();
    // this.listenToParentArriving();
  },
  methods: {
    // async fetchAlertsFromBackend() {
    //   try {
    //     const teacherId = localStorage.getItem('user_id'); // assuming you store auth info here
    //     const response = await axios(`/location/getNotificationsForTeacher?user_id=${teacherId}`);
    //     const data  = response.data.data ;
    //     this.parentAlerts = data;
    //   } catch (error) {
    //     console.error('Failed to fetch alerts:', error);
    //   }
    // },

    // playSound() {
    //   const audio = new Audio(require('@/assets/notification.mp3'));
    //   audio.play().catch(err => {
    //     console.warn('Autoplay prevented or error:', err);
    //   });
    // },

    // listenToParentArriving() {
    //   const teacherId = localStorage.getItem('user_id');

    //   window.Echo.channel(`teacher.${teacherId}`)
    //     .listen('.ParentArriving', (event) => {
    //       // Log to check what teacher is receiving the event
    //   console.log('Event teacher_id:', event.teacher_id);
    //   console.log('LocalStorage teacher_id:', parseInt(teacherId));

    //   // Ensure we skip the notification if it's not the correct teacher
    //   if (event.teacher_id !== parseInt(teacherId)) {
    //     console.log("Skipping: Not this teacher's alert.");
    //     return false;
    //   }

    //       // Remove existing alert for the same student
    //       this.parentAlerts = this.parentAlerts.filter(
    //         alert => alert.student_id !== event.student_id
    //       );

    //       const newAlert = {
    //         student_id: event.student_id,
    //         student_name: event.student_name,
    //         parent_name: event.parent_name,
    //         latitude: event.latitude,
    //         longitude: event.longitude
    //       };

    //       this.parentAlerts.push(newAlert);
    //       this.playSound();

    //       this.$notify({
    //         title: `Parent Arriving`,
    //         text: `${event.parent_name} (for ${event.student_name}) is near the school.`,
    //         type: 'info'
    //       });
    //     })
    //     .error(error => {
    //       console.error('Error subscribing to channel:', error);
    //     });
    // }
  }
};
</script>

<style scoped>
.notifications-container {
  max-width: 700px;
  margin: 20px auto;
  padding: 1.5rem;
  background: #f9f9f9;
  border-radius: 1rem;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);
}

.title {
  text-align: center;
  font-size: 1.8rem;
  margin-bottom: 1.5rem;
  color: #444;
}

.alerts-grid {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.alert-card {
  display: flex;
  align-items: center;
  padding: 1rem;
  background: #ffffff;
  border-left: 5px solid #3b82f6;
  border-radius: 0.75rem;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.04);
  transition: all 0.3s ease;
}

.alert-card:hover {
  transform: scale(1.02);
  background: #f0f8ff;
}

.icon img {
  width: 48px;
  height: 48px;
  margin-right: 1rem;
}

.details {
  flex-grow: 1;
}

.parent-name,
.student-name,
.location {
  margin: 2px 0;
  font-size: 0.95rem;
}

.empty-state {
  text-align: center;
  color: #888;
  font-size: 1rem;
  padding: 2rem;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
